import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import {
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./constants";

const { ACCOUNTS, REQUEST_STATE, GENERATE_OTP_RECEIVER, UIGP_OTP_VERIFIED } =
  STATE_IDENTIFIER;

export default {
  [ACCOUNTS]: {
    [LOADER_IDENTIFIER]: false,
    [LIST_IDENTIFIER]: [],
  },
  [REQUEST_STATE]: IResponseState.PENDING,
  [GENERATE_OTP_RECEIVER]: "",
  [UIGP_OTP_VERIFIED]: false,
};
